<div
  class="container-fluid tw-relative tw-bg-white tw-overflow-hidden tw-py-10 tw-min-h-[100dvh] tw-flex tw-items-center"
>
  <!-- Fondo decorativo inferior derecho -->
  <div
    class="tw-absolute tw-inset-0 tw-bg-no-repeat tw-bg-left-bottom tw-bg-[url('/assets/images/logoOrange2.png')] tw-opacity-60 tw-blur-xs tw-z-0 tw-pointer-events-none"
    style="background-size: 280px"
  ></div>

  <!-- Contenido centrado vertical y horizontalmente -->
  <div
    class="tw-relative tw-z-10 tw-container tw-mx-auto tw-px-4 sm:tw-px-6 tw-w-full"
  >
    <div class="tw-flex tw-items-center tw-justify-center">
      <div
        class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-8 md:tw-gap-16 tw-items-center tw-w-full"
      >
      <div class="swiper-container tw-block md:tw-hidden">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img
            class="tw-rounded-2xl tw-border-2 tw-border-[#F67011]/30 tw-shadow-lg tw-w-full tw-h-64 tw-object-cover tw-object-center tw-transition-transform tw-duration-300 hover:tw-scale-105"
            src="assets/images/001.jpeg"
            alt="Imagen 1"
          />
          
          </div>
          <div class="swiper-slide">
            <img
            class="tw-rounded-2xl tw-border-2 tw-border-[#F67011]/30 tw-shadow-lg tw-w-full tw-h-64 tw-object-cover tw-object-center tw-transition-transform tw-duration-300 hover:tw-scale-105"
            src="assets/images/002.jpeg"
            alt="Imagen 2"
          />
          
          </div>
          <div class="swiper-slide">
            <img
            class="tw-rounded-2xl tw-border-2 tw-border-[#F67011]/30 tw-shadow-lg tw-w-full tw-h-64 tw-object-cover tw-object-center tw-transition-transform tw-duration-300 hover:tw-scale-105"
            src="assets/images/003.jpeg"
            alt="Imagen 3"
          />
          
          </div>
        </div>
      
     
      </div>
      

        <!-- Contenedor de imágenes decorativas -->
        <div
          class="tw-relative tw-w-full tw-h-auto md:tw-h-[600px] tw-hidden md:tw-block"
        >
          <!-- Imagen 1 - Arriba a la izquierda -->
          <img
            class="tw-rounded-3xl hover:-tw-translate-y-2 tw-transition-all tw-duration-300 tw-border-2 tw-border-[#F67011]/20 tw-shadow-xl tw-object-cover tw-h-[300px] tw-w-[200px] tw-absolute tw-top-0 tw-left-0"
            src="assets/images/002.jpeg"
            alt="Imagen superior izquierda"
          />

          <!-- Imagen 2 - Centro derecha -->
          <img
            class="tw-rounded-3xl tw-border-2 hover:tw-scale-110 tw-duration-300  tw-border-[#F67011]/20 tw-shadow-xl tw-object-cover tw-h-[500px] tw-absolute tw-top-1/2 tw-right-0 tw-translate-y-[-50%]"
            src="assets/images/001.jpeg"
            alt="Imagen centro derecha"
          />

          <!-- Imagen 3 - Abajo a la izquierda -->
          <img
            class="tw-rounded-3xl tw-border-2 hover:-tw-translate-y-2 tw-transition-all tw-duration-300 tw-border-[#F67011]/20 tw-shadow-xl tw-object-cover tw-h-[300px] tw-w-[200px] tw-absolute -tw-bottom-10 tw-left-0"
            src="assets/images/003.jpeg"
            alt="Imagen inferior izquierda"
          />
        </div>

        <!-- Columna derecha -->
        <div
          class="tw-bg-white tw-rounded-3xl tw-p-6 sm:tw-p-8 md:tw-p-16 tw-border-2 tw-border-[#F67011]/20 tw-shadow-2xl tw-max-w-2xl tw-mx-auto tw-animate-slide-up tw-transition-all hover:tw-shadow-[0_20px_50px_rgba(246,112,17,0.15)]"
        >
          <div class="tw-space-y-6 sm:tw-space-y-8 tw-break-words">
            <!-- MISIÓN -->
            <div class="tw-flex tw-items-start tw-gap-4 sm:tw-gap-6 group">
              <div>
                <h3
                  class="tw-font-montserrat tw-text-base sm:tw-text-xl tw-mb-1 tw-text-justify"
                >
                  <span class="tw-text-[#F67011]">MISIÓN :</span> Conectar a
                  nuestros clientes con el mundo digital, brindando soluciones
                  de internet de alta calidad que superen sus expectativas, de
                  manera eficiente.
                </h3>
              </div>
            </div>

            <!-- VISIÓN -->
            <div class="tw-flex tw-items-start tw-gap-4 sm:tw-gap-6 group">
              <div>
                <h3
                  class="tw-font-montserrat tw-text-base sm:tw-text-xl tw-mb-1 tw-text-justify"
                >
                  <span class="tw-text-[#F67011]">VISIÓN:</span> Ser el socio
                  tecnológico de confianza de nuestros clientes, brindando
                  soluciones personalizadas de conectividad que impulsen su
                  crecimiento y desarrollo.
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
